/**
 * Checks if a video is upcoming based on its type and status.
 *
 * @param {object} videoData - The video data object.
 * @returns {boolean} - True if the video is upcoming, false otherwise.
 */
export const checkIfVideoUpcoming = videoData => {
  return checkIfVideoTypeLive(videoData) && videoData.status === "upcoming";
};

/**
 * Checks if a video has ended based on its type and status.
 *
 * @param {object} videoData - The video data object.
 * @returns {boolean} - True if the video has ended, false otherwise.
 */
export const checkIfVideoEnded = videoData => {
  return checkIfVideoTypeLive(videoData) && videoData.status === "ended";
};

/**
 * Checks if a video is live based on its status.
 *
 * @param {object} videoData - The video data object.
 * @returns {boolean} - True if the video is live, false otherwise.
 */
export const checkIfVideoLive = videoData => {
  return videoData.status === "live";
};

/**
 * Checks if a video is of type "live" based on its video_type property.
 *
 * @param {object} videoData - The video data object.
 * @returns {boolean} - True if the video is of type "live", false otherwise.
 */
export const checkIfVideoTypeLive = videoData => {
  return videoData.video_type === "live";
};

export function hasLiveEventEnded(video) {
  return (
    checkIfVideoEnded(video) ||
    isPastPublicationEndDate(video?.additional_properties?.publicationEndDate)
  );
}

export function isLiveEventUpcoming(video) {
  return checkIfVideoUpcoming(video) || !isPastDisplayDate(video?.display_date);
}

export const isPastPublicationEndDate = publicationEndDate => {
  if (!publicationEndDate) return false;
  try {
    const now = new Date();

    const pubEndDate = new Date(publicationEndDate);
    // 1 hour adjustment in case of weird end-user time settings, copied from Powa: https://github.com/WPMedia/wp-powa-player/blob/main/src/js/plugins/Wapo/WapoTools.js#L505
    pubEndDate.setHours(pubEndDate.getHours() + 1);

    if (now > pubEndDate) {
      return true;
    }
  } catch (e) {
    console.error("Unable to parse publicationEndDate", e);
  }
  return false;
};

export const isPastDisplayDate = displayDate => {
  if (!displayDate) return false;
  try {
    const now = new Date();

    const displayDateDate = new Date(displayDate);
    displayDateDate.setMinutes(displayDateDate.getMinutes());

    if (now > displayDateDate) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.debug(e);
  }
};
